module.exports = __webpack_public_path__ + "static/media/lvl-group-9.7bad8652.png";